import { useEffect, useState } from "react";
import { AccountReportDto, ReportService } from "../../../api/psc";
import { Spinner } from "../../../components/exports";
import ReportItem from "../components/ReportItem";

// updated
export default function SelectReport(props: {
    onReportChange: (AccountReportDto) => void;
}) {
    const [reports, setReports] = useState<AccountReportDto[]>([]);
    const [fetchingReports, setFetchingReports] = useState(true);

    useEffect(() => {
        ReportService.getReports("1").then((r) => {
            setReports(r);
            setFetchingReports(false);
        });
    }, []);

    return (
        <>
            {fetchingReports && <Spinner />}

            {reports.map((r) => (
                <ReportItem
                    key={r.type}
                    onSelected={() => props.onReportChange(r)}
                    report={r}
                />
            ))}
        </>
    );
}
